
import {Component, Vue} from 'vue-property-decorator';
import workbok from './sw';

@Component
export default class App extends Vue {
  prompt = false;

  created() {
    if (workbok) {
      workbok.addEventListener('waiting', () => {
        this.prompt = true;
      });
    }
  }

  async accept() {
    this.prompt = false;
    await workbok.messageSW({type: 'SKIP_WAITING'});
  }
  async update() {
    this.prompt = false;
    await workbok.messageSW({type: 'SKIP_WAITING'});
  }
}
